import React, { useContext } from 'react';
import { PrimaryButton, Link } from '@fluentui/react';

import { getIconSvg } from 'utils/svg';
import { getSolutionUrl } from 'utils/urls';
import { Title } from 'components/common/Title';
import { StepProps } from 'components/deployment/Deployment';
import { stepStyles as styles } from 'components/steps/commonStyles';
import { StepContainer } from 'components/common/steps/StepContainer';
import TranslationsContext from 'translations/TranslationsContext';
import translationKeys from 'translationKeys';


export const Success = ({ deployment }: StepProps) => {
	const { t } = useContext(TranslationsContext)!;
	const solutionUrl = getSolutionUrl(deployment.organizationId);

	return (
		<StepContainer className={styles.root}>
			<Title>{t(translationKeys.Success.Step.Title)}</Title>
			<p className={styles.formElement}>{t(translationKeys.Success.Step.Paragraph.First.Text)} <Link underline={true} target="_blank" href="https://docs.microsoft.com/dynamics365/industry/nonprofit/fundraising-engagement-get-started-overview"> {t(translationKeys.Success.Step.Paragraph.First.LinkText)}</Link></p>
			<p className={styles.emphasized} role='alert'>{t(translationKeys.Success.Step.Paragraph.Second.Text)}</p>
			<PrimaryButton className={styles.button} iconProps={{ iconName: 'OpenInNewWindow' }} onClick={() => window.open(solutionUrl)}>{t(translationKeys.Success.Step.OpenWindowButton.Text)}</PrimaryButton>
			<img alt={t(translationKeys.Success.Step.Img.Alt)} className={styles.smallGroundImg} src={getIconSvg('process', 'images')} />
		</StepContainer>
	);
};
